import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { KIOSKTIMEOUT } from '@constants';
import { TimeoutDialogComponent } from '@dialogs/timeout-dialog/timeout-dialog.component';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

// This service handles the first layer of timer for an inactive screen.
// If the screen is not used in clicks, or typeing in 5mins the screen will open the timeout-dialog,
// which gives another 30 seconds before returning to the welcome screen.
export class TimeoutService implements OnDestroy {
  clickObservable: Observable<Event> = fromEvent(document, 'click');
  keyboardObservable: Observable<Event> = fromEvent(document, 'keypress');
  private clickSubscription: Subscription;
  timeout: ReturnType<typeof setTimeout>;

  constructor(private readonly dialog: MatDialog) {}

  initTimeoutService() {
    const combinedObservable$ = merge(this.clickObservable, this.keyboardObservable);
    // Listen for any click or keyboard inputs.
    this.clickSubscription = combinedObservable$.subscribe(() => {
      this.resetTimeout();
    });

    this.initTimeout();
  }

  initTimeout() {
    this.timeout = setTimeout(() => {
      const dialogRef = this.dialog.open(TimeoutDialogComponent, {});

      dialogRef?.afterClosed().subscribe((response: string) => {
        if (response === 'close') {
          this.resetTimeout();
        } else if (
          window.location.href.includes('welcome') ||
          window.location.href.includes('finished') ||
          window.location.href.includes('reception')
        ) {
          this.resetTimeout();
          window.location.reload();
        }
        this.resetTimeout();
      });
    }, KIOSKTIMEOUT);
  }

  resetTimeout() {
    clearTimeout(this.timeout);
    this.initTimeout();
  }

  removeTimeOut() {
    clearTimeout(this.timeout);
    this.clickSubscription?.unsubscribe();
  }

  ngOnDestroy(): void {
    this.removeTimeOut();
  }
}
